require("normalize.css/normalize.css");
require("./styles/index.scss");

import EyeLine from "./elements/EyeLine";
import randomRGBA from "./utils/randomRGBA";
import gradientGenerator from "./utils/gradientGenerator";
const canvas = document.querySelector(".main-canvas");
let canvasWidth = window.innerWidth * window.devicePixelRatio;
let canvasHeight = window.innerHeight * window.devicePixelRatio;
canvas.width = canvasWidth;
canvas.height = canvasHeight;
const ctx = canvas.getContext("2d");
let time = 0;
let lines = 0;
let scale = 0;
let colors = [];
let points = [];
const update = () => {
  time += 0.01;
  ctx.save();
  ctx.translate(canvasWidth / 2, canvasHeight / 2);
  if (time < 3) {
    points.map((point, index) => point.update(time));
    requestAnimationFrame(update);
  }
  ctx.beginPath();
  ctx.fillStyle = "black";
  ctx.arc(0, 0, 100, 0, Math.PI * 2, true);
  ctx.fill();
  ctx.closePath();
  ctx.restore();
};
const init = () => {
  ctx.clearRect(0, 0, canvasWidth, canvasHeight);
  time = 0;
  lines = 300;
  scale = 0;
  colors = gradientGenerator(randomRGBA(), randomRGBA(), lines);
  points = [];
  for (let x = 0; x < lines; x++) {
    scale = 100 + time * 100;
    points.push(
      new EyeLine(
        Math.cos(0) * scale,
        Math.sin(0) * scale,
        0.5,
        ctx,
        colors[x],
        scale,
        lines,
        x
      )
    );
  }
  requestAnimationFrame(update);
};

window.addEventListener("click", () => {
  init();
});

init();
